import { runCollectionsSubnav } from './list-collections-subnav/list-collections-subnav';
import { initControlsSectionTiles } from './list-collections-controls/list-collections-controls';
import { initPoeControlsSectionTiles } from './list-collections-poe-controls/list-collections-poe-controls';
import { initSwitchesAndPlugsSectionTiles } from './list-collections-switches-and-plugs/list-collections-switches-and-plugs';
import { initBundlesSectionTiles } from './list-collections-bundles/list-collections-bundles';
import { initBundlesCloseoutSectionTiles } from './list-collections-bundles-closeout/list-collections-bundles-closeout';
import { initFramesSectionTiles } from './list-collections-frames/list-collections-frames';
import { initRefurbishedControlsSectionTiles } from './list-collections-refurbished-controls/list-collections-refurbished-controls';
import { initPlugInControlsSectionTiles } from './list-collections-plug-in-controls/list-collections-plug-in-controls';
import { initProductWishListModal } from '../../snippets/product-wish-list-modal/product-wish-list-modal';

initBundlesSectionTiles();
initPlugInControlsSectionTiles();
initControlsSectionTiles();
initPoeControlsSectionTiles();
initBundlesCloseoutSectionTiles();
initSwitchesAndPlugsSectionTiles();
initRefurbishedControlsSectionTiles();
initFramesSectionTiles();
initProductWishListModal({
  variantId: null,
});

window.addEventListener('load', () => {
  runCollectionsSubnav(); // NOTE: Depends on $ (window.Helpers.scrollToElement)
});
